export const PORTALS_CLS = 'sparky-portals'
export const PANWDS_TW2_CLS = 'panwds-tw2'
export const PANWDS_TW3_CLS = 'panwds-tw3'
export const HEADLESSUI_PORTAL_ROOT = 'headlessui-portal-root'
export const CONTAINER_ADD_TW2_MATCHES = '.panwds-tw2, .panwds-tw3, .panwds-tw2 *, .panwds-tw3 *, body, #fawkes-root'
